import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { EvCore } from "ev-core";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";
import { NewDwellingSalesDataService } from "src/services/new-dwellings/new-dwelling-sales-data.service";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";
import { EvProgressBarComponent } from "src/app/shared-components/ev-progress-bar/ev-progress-bar.component";
import { EVNDSaleStateType } from "src/models/new-dwelling/new-dwelling.enums";
import { ConvertUtil } from "src/util/tools/convert.util";

@Component({
    selector: "new-dwelling-stage-item",
    imports: [CommonModule, EvCore, EvProgressBarComponent],
    templateUrl: "./new-dwelling-stage-item.component.html",
    styleUrl: "./new-dwelling-stage-item.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewDwellingStageItemComponent {
    projectStage = input.required<IProjectStageDto>();
    authService: EvAuthorizationService = inject(EvAuthorizationService);
    soldRatio = computed(() => this.projectStage().numUnits > 0 ? this.projectStage().numberSold / this.projectStage().numUnits : 0);
    soldPercentage = computed(() => Math.round(this.soldRatio() * 100));
    estateTypeCssClass = computed(() => ConvertUtil.estateTypesToCssClass(this.projectStage().estateTypes ?? []));

    EVNDSaleStateType = EVNDSaleStateType;

    private readonly newDwellingSalesDataService: NewDwellingSalesDataService = inject(NewDwellingSalesDataService);

    selectStage(stage: IProjectStageDto): void {
        this.newDwellingSalesDataService.setSelectedStage(stage);
    }
}
